import { requestHandler } from "../lib/utils/network-client";

export function getContactSubmissions(params = {}) {
  return requestHandler("/contact-submissions", {
    params
  });
}
